import $ from 'jquery';

export default class AdminService {
    static listUsers() {
        return $.ajax({
            url: '/rest/admin/users',
            type: 'get'
        });
    }

    static saveUser(user) {
        return $.ajax({
            url: '/rest/admin/user',
            type: 'post',
            contentType: 'application/json',
            data: JSON.stringify(user)
        });
    };

    static activateUser(user) {
        return $.ajax({
            url: '/rest/admin/activate-user',
            type: 'post',
            contentType: 'application/json',
            data: JSON.stringify(user)
        });
    }

    static saveProject(project) {
        return $.ajax({
            url: '/rest/admin/project',
            type: 'post',
            contentType: 'application/json',
            data: JSON.stringify(project)
        });
    }
}


// WEBPACK FOOTER //
// ./src/admin/admin-service.js